import React from "react";
import { Spin } from "antd"; // 加载动画
import { Col, Row } from "antd"; // 使居中

export default function Loading() {
  return (    
    <Row
      type="flex"
      justify="center" //justify: 水平对齐 start center end
      align="middle"   //align : 垂直对齐 left middle right
      style={{ minHeight: "100vh", textAlign: "center" }}
    >
      <Col span={4}>
        <div>
          <Spin
            delay={300}
            style={{
              // margin: '20px 0',
              width:35,
              height:35,
              margin: "auto",
              marginBottom: "20px",
              // padding: "30px 30px",
              textAlign: "center",
              background: "rgba(0, 0, 0, 0.02)",
              borderRadius: "4px",
            }}
          />
        </div>
      </Col>
    </Row>
  );
}
